import { Badge, Box, Grid } from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircle';
import React from 'react';
import { CartMetadata } from 'src/common/interfaces/dtos/ICartMetadata';
import { styles } from './order-item-styles';

interface OrderItemProps {
  order: CartMetadata;
  isSelected?: boolean;
  index: number;
  onSelectOrder: Function;
}

const OrderItem = ({ order, isSelected, index, onSelectOrder }: OrderItemProps): JSX.Element => {
  const classes = styles({ index });
  return (
    <Badge
      anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      showZero={true}
      invisible={!isSelected}
      badgeContent={<CheckCircle />}
      classes={{ root: classes.badge }}
      component='div'
    >
      <Box
        data-testid={`order-${index}`}
        className={`${classes.resultsItem} ${isSelected ? `${classes.selected}` : ''}`}
        onClick={(): void => onSelectOrder(order.orderId)}
      >
        <Grid
          container
          className={`fullHeight`}
          justifyContent='space-between'
          alignItems='center'
          wrap='nowrap'
        >
          <Grid item>
            {`${order.beginDateTime.getMonth() +
              1}/${order.beginDateTime.getDate()}/${order.beginDateTime.getFullYear()}`}
          </Grid>
          <Grid item>{order.customerName}</Grid>
          <Grid item>{`$${order.totalAmount}`}</Grid>
        </Grid>
      </Box>
    </Badge>
  );
};

export default OrderItem;
